import * as rcc from "../../constants/rcc";
import * as settings from "../../constants/settings";

import Colorant from "./Colorant";

/**
 * @class MachineColorant
 */
export default class MachineColorant extends Colorant {
    /**
     * @param {Number} id
     * @param {String} name
     * @param {String} displayName
     * @param {String} rgb
     * @param {Number} amount
     * @param {String} amountType
     * @param {Number} density
     * @param {String} ufi
     * @param {Number} validationResult
     * @param {String} warningText
     * @param {Number} dispensingLogic
     * @param {Number} correction
     * @param {Number} realAmount
     */
    constructor(
        id,
        name,
        displayName,
        rgb,
        amount,
        amountType = settings.UNIT_ML,
        density = 1,
        ufi = null,
        validationResult = rcc.RCC_VALIDATION_OK,
        warningText = "",
        dispensingLogic = rcc.DISPENSING_LOGIC_AUTOMATIC,
        correction = 0,
        realAmount = 0
    ) {
        super(
            id,
            name,
            displayName,
            rgb,
            amount,
            amountType,
            density,
            ufi,
            validationResult,
            warningText,
            dispensingLogic,
            correction,
            realAmount
        );
    }

    /**
     * @return {MachineColorant}
     */
    clone = () => {
        return new MachineColorant(
            this._id,
            this._name,
            this._displayName,
            this._rgb,
            this._amount,
            this._amountType,
            this._density,
            this._ufi,
            this._validationResult,
            this._warningText,
            this._dispensingLogic,
            this._correction,
            this._realAmount
        );
    };
}
